/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDateRangePicker } from '@angular/material/datepicker';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DTypeGoLiveAction, DTypeRepository, DTypeToGoLiveRequest, DTypeToGoLiveSchedule } from '@grupo-constant/next-dtype/types';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoService } from '@ngneat/transloco';
import { format, formatISO } from 'date-fns';
import { catchError, map, Subject, takeUntil, throwError } from 'rxjs';
import { ScheduleGoLiveBody } from './schedule-go-live-dialog.types';
import { DTypeToGoLiveScheduleBody } from '../../core/dtype/dtype.types';

@Component({
    selector: 'schedule-go-live-dialog',
    templateUrl: './schedule-go-live-dialog.component.html',
    styles: [
        /* language=SCSS */
        `
            .schedule-go-live-dialog-panel {
                @screen md {
                    @apply w-128;
                }

                .mat-mdc-dialog-container {

                    .mat-mdc-dialog-surface {
                        padding: 0 !important;
                    }
                }
            }
        `
    ],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ScheduleGoLiveDialogComponent implements OnInit, OnDestroy {

    date: FormControl = new FormControl<string>(undefined);
    observations: FormControl = new FormControl<string>(undefined);
    datemin: string;
    readOnly: boolean = false;
    formGroup = new FormGroup({
        time: new FormControl<NgbTimeStruct | string>(undefined),
    });

    private unsubscribe = new Subject<void>();

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ScheduleGoLiveBody,
        public matDialogRef: MatDialogRef<ScheduleGoLiveDialogComponent>,
        private transloco: TranslocoService
    ) { }

    ngOnInit() {
        this.datemin = format(new Date(), 'yyyy-MM-dd');

        this.date.valueChanges.pipe(takeUntil(this.unsubscribe)).subscribe((value) => {
            this.dateControlChanged(value);
        });
    }

    ngOnDestroy() {
        this.unsubscribe.complete();
    }

    closeDialog(result?: DTypeToGoLiveScheduleBody): void {
        this.matDialogRef.close(result);
    }

    openDatepickerOnClick(datepicker: MatDateRangePicker<Date>) {
        if (!datepicker.opened && !this.readOnly) {
            datepicker.open();
        }
    }

    save() {
        let _date = null;
        if (this.date.value) {
            if (this.formGroup.controls['time'].value){
                _date = formatISO(Date.parse(this.date.value + 'T' + this.formGroup.controls['time'].value));
            } else {
                _date = formatISO(Date.parse(this.date.value));
            }
        } else if (this.formGroup.controls['time'].value) {
            _date = formatISO(Date.parse(this.datemin + 'T' + this.formGroup.controls['time'].value));
        }

        const inner: DTypeToGoLiveSchedule = {
            date: _date ?? null,
            observations: this.observations.value ?? null,
            actions: this.data.dtypeToGoLiveSchedule.actions
        };
        const body: DTypeToGoLiveScheduleBody = {
            uri: this.data.uri,
            dtypeToGoLiveSchedule: inner,
        };
        this.closeDialog(body);
    }

    private dateControlChanged(value: Date | string) {
        if (value instanceof Date) {
            this.date.setValue(format(value, 'yyyy-MM-dd'), { emitEvent: false });
        }
    }

}
